import { memo, useMemo, useState } from "react";
import { Flex, Heading, useBreakpointValue, useInterval } from "@chakra-ui/react";

import { FadeInOut } from "../FadeInOut";
import { HeadingVariants } from "../../../theme/variants";

interface TimerProps {
  seconds?: number;
  reverse?: boolean;
  small?: boolean;
  fontSize?: string;
}

export const Timer = memo(({ seconds = 0, reverse, small = false, fontSize }: TimerProps) => {
  const [countdown, setCountdown] = useState(seconds);

  useInterval(() => {
    if (reverse) {
      setCountdown((prev) => prev + 1);
    } else {
      setCountdown((prev) => (prev - 1 < 0 ? 0 : prev - 1));
    }
  }, 1000);

  const numbers = useMemo(() => {
    if (countdown > 60) {
      return `${Math.floor(countdown / 60)}:${countdown % 60 < 10 ? "0" : ""}${countdown % 60}`.split("");
    }

    if (countdown < 10) return ["0", String(countdown)];

    return String(countdown).split("");
  }, [countdown]);

  const headingVariant = useBreakpointValue({
    base: countdown > 60 ? HeadingVariants.largeLg : HeadingVariants.largeXl,
    md: HeadingVariants.largeXl,
  });

  return (
    <Heading variant={small ? HeadingVariants.smallSm : headingVariant} fontSize={fontSize} as={Flex}>
      {numbers.map((value, index) => (
        <FadeInOut key={countdown > 60 ? index + 100 : index} value={value} />
      ))}
    </Heading>
  );
});
